import { z } from 'zod';

export const CentavosSchema = z.number().int();

export type Centavos = z.infer<typeof CentavosSchema>;

export function formatBRL(centavos: Centavos): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(centavos / 100);
}

export function parseBRL(value: string): Centavos {
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return 0;
  return parseInt(digits, 10);
}
